module.exports = __webpack_public_path__ + "img/bankicon2.916d4897.png";